import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCbseClassData } from '../../../../actions/cbseClassActions';
import { isEmpty, get } from 'lodash';
import { useTheme } from '@material-ui/core/styles';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import ListSubheader from '@material-ui/core/ListSubheader';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from 'react-router-dom';
import './styles.scss';
import { Grid } from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import NoData from '../../../../components/NoData';
import PageHeading from '../../../../components/PageHeading';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import LoadingSkeleton from '../../../../components/LoadingSkeleton';
import ScrollToTop from '../../../../components/ScrollToTop';

export default function CbseClassesLayout() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const [isFetching, setIsFetching] = useState(false);
  const [subject, setsubject] = React.useState('');
  const [selectedChapter, setselectedChapter] = React.useState('');
  const [selectedTopic, setselectedTopic] = React.useState('');
  const [showchapters, showChaptersDailog] = React.useState(false);
  const [chapterList, setChapterList] = React.useState([]);
  const [showTopics, showTopicDailog] = React.useState(false);
  const [topicsList, setTopicsList] = React.useState([]);
  const [visible, setVisible] = React.useState({
    subject: true,
    chapter: false,
    topic: false,
  });

  const dispatch = useDispatch();

  const jwtToken = useSelector((state) =>
    get(state, 'loginReducer.data.jwt', '')
  );

  const cbseClassData = useSelector((state) =>
    get(state, 'cbseClassReducer.data', [])
  );

  const errorMessage = useSelector((state) =>
    get(state, 'cbseClassReducer.errorMessage', '')
  );

  // useEffect(() => {
  //   fetchCbseClassData(jwtToken, dispatch);
  // }, []);

  useEffect(() => {
    setIsFetching(true);
    fetchCbseClassData(jwtToken, dispatch).then(() => {
      setIsFetching(false);
    });
  }, []);

  const fetchSubjectList = () => {
    const subjects = [];
    cbseClassData.length !== 0 &&
      !isEmpty(cbseClassData) &&
      cbseClassData.map((subject) => {
        subjects.push(subject.SubjectName);
      });
    return subjects;
  };

  const fetchChapterList = (subject) => {
    let listChapterData = [];
    let chapters = [];
    if (subject != '') {
      listChapterData = cbseClassData.filter((item) => {
        return item.SubjectName == subject;
      });
    }
    let classList = listChapterData[0].listChapter;
    classList.length !== 0 &&
      !isEmpty(classList) &&
      classList.map((ch) => {
        chapters.push(ch.ChapterName);
        return chapters;
      });
    setChapterList(chapters);
  };

  const fetchTopicsList = (chapter) => {
    let listSubjectData = [];
    let listChapterData = [];

    if (subject != '' && chapter != '') {
      listSubjectData = cbseClassData.filter((item) => {
        return item.SubjectName === subject;
      });

      listChapterData = listSubjectData[0].listChapter.filter((item) => {
        return item.ChapterName === chapter;
      });

      let classList = listChapterData[0].listClass;
      classList.length !== 0 && !isEmpty(classList) && setTopicsList(classList);
    }
  };

  const handleChangeSubject = (event, item) => {
    setsubject(item);
    showTopicDailog(false);
    showChaptersDailog(true);
    fetchChapterList(item);
    setselectedChapter('');
    setselectedTopic('');
    setVisible({ subject: false, chapter: true, topic: false });
  };

  const handleChangeChapter = (event, item) => {
    setselectedChapter(item);
    showTopicDailog(true);
    fetchTopicsList(item);
    setselectedTopic('');
    setVisible({ subject: false, chapter: false, topic: true });
  };

  const subjects = fetchSubjectList();

  const handleTopicSelect = (event, item) => {
    setselectedTopic(item);
  };

  const handleBackButton = () => {
    visible.chapter === true
      ? setVisible({ subject: true, chapter: false, topic: false })
      : setVisible({ subject: false, chapter: true, topic: false });
  };

  // For Scroll only in desktop
  const MyScrollBar = matches === true ? PerfectScrollbar : 'div';

  return (
    <React.Fragment>
      <PageHeading titlePrimary="CBSE" titleSecondary="Classes" />

      {isFetching ? (
        <LoadingSkeleton type="listItem" />
      ) : !isEmpty(cbseClassData) && cbseClassData.length !== 0 ? (
        <>
          <Card className="card body-select-dailogs">
            {matches === false && visible.subject === false && (
              <div onClick={handleBackButton} className="back-btn">
                <ArrowBackIcon /> Back
              </div>
            )}
            <Grid container className="multiple-list">
              <Grid item xs>
                <div className="list-card-subjects border-none">
                  <MyScrollBar>
                    <List
                      component="nav"
                      aria-labelledby="nested-list-subheader"
                      subheader={
                        <ListSubheader
                          component="div"
                          id="nested-list-subheader"
                        >
                          {!(matches === false && visible.subject === false) &&
                            'Select a Subject'}
                        </ListSubheader>
                      }
                    >
                      <ScrollToTop />
                      {!(matches === false && visible.subject === false) &&
                        subjects.map((item, index) => (
                          <ListItem
                            button
                            key={index}
                            value={item}
                            onClick={(e) => handleChangeSubject(e, item)}
                          >
                            <ListItemText
                              primary={item}
                              className={item === subject ? 'active' : ''}
                            />
                            <ListItemIcon>
                              <KeyboardArrowRightIcon />
                            </ListItemIcon>
                          </ListItem>
                        ))}
                    </List>
                  </MyScrollBar>
                </div>
              </Grid>
              {!(matches === false && visible.chapter === false) &&
                showchapters &&
                chapterList.length != 0 && (
                  <Grid item xs>
                    <div className="list-card-subjects">
                      <MyScrollBar>
                        <List
                          component="nav"
                          aria-labelledby="nested-list-subheader"
                          subheader={
                            <ListSubheader
                              component="div"
                              id="nested-list-subheader"
                            >
                              Select a Topic
                            </ListSubheader>
                          }
                        >
                          <ScrollToTop />
                          {chapterList.map((item, index) => (
                            <ListItem
                              button
                              key={index}
                              value={item}
                              onClick={(e) => handleChangeChapter(e, item)}
                            >
                              <ListItemText
                                primary={item}
                                className={
                                  item === selectedChapter ? 'active' : ''
                                }
                              />
                              <ListItemIcon>
                                <KeyboardArrowRightIcon />
                              </ListItemIcon>
                            </ListItem>
                          ))}
                        </List>
                      </MyScrollBar>
                    </div>
                  </Grid>
                )}
              {!(matches === false && visible.topic === false) &&
                showTopics &&
                topicsList.length !== 0 && (
                  <Grid item xs>
                    <div className="list-card-subjects">
                      <MyScrollBar>
                        <List
                          component="nav"
                          aria-labelledby="nested-list-subheader"
                          subheader={
                            <ListSubheader
                              component="div"
                              id="nested-list-subheader"
                            >
                              Select a Class
                            </ListSubheader>
                          }
                        >
                          <ScrollToTop />
                          {topicsList.map((item, index) => (
                            <Link
                              key={item.UniqueCode}
                              to={
                                item.ModuleCode === null
                                  ? '/cbse-classes/' + item.UniqueCode
                                  : '/cbse-classes/' +
                                    item.UniqueCode +
                                    '/' +
                                    item.ModuleCode
                              }
                            >
                              <ListItem
                                button
                                key={index}
                                value={item.ModuleNo}
                                onClick={(e) => handleTopicSelect(e, item)}
                              >
                                <ListItemText
                                  primary={item.ModuleNo}
                                  className={
                                    item === selectedTopic ? 'active' : ''
                                  }
                                />
                                <ListItemIcon>
                                  <KeyboardArrowRightIcon />
                                </ListItemIcon>
                              </ListItem>
                            </Link>
                          ))}
                        </List>
                      </MyScrollBar>
                    </div>
                  </Grid>
                )}
            </Grid>
          </Card>
        </>
      ) : (
        <NoData
          message={!isEmpty(errorMessage) ? errorMessage : 'No data Available'}
        />
      )}
    </React.Fragment>
  );
}
